import { ChangeDetectionStrategy, Component, EventEmitter, input, InputSignal, Output } from '@angular/core';
import { AddToCartModel, ProductModel } from '@libs/shop/models';
import { ProductDetailBundleFormComponent } from './product-detail-bundle-form';
import { ProductDetailFormComponent } from './product-detail-form';

@Component({
  selector: 'ui-product-detail-view',
  templateUrl: './product-detail-view.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ProductDetailFormComponent,
    ProductDetailBundleFormComponent,
  ],
})
export class ProductDetailViewComponent {
  @Output()
  public addToShoppingList: EventEmitter<AddToCartModel<ProductModel>> = new EventEmitter<AddToCartModel<ProductModel>>();

  public product: InputSignal<ProductModel> = input.required();
}
